import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { EnvironmentService } from '../services/environment.service';

/**
 * HTTP Interceptor function that prepends the API URL from environment configuration
 * to all API requests that don't already have a full URL.
 */
export const apiUrlInterceptor: HttpInterceptorFn = (req, next) => {
  const environmentService = inject(EnvironmentService);

  // Check if the URL is already absolute (starts with http:// or https://)
  if (req.url.startsWith('http://') || req.url.startsWith('https://')) {
    return next(req);
  }

  // Get the API URL from environment configuration
  const apiUrl = environmentService.getApiBaseUrl();

  // Clone the request and prepend the API URL
  const apiReq = req.clone({
    url: `${apiUrl}${req.url}`,
  });

  return next(apiReq);
};
